import { CLEAR_ERRORS } from '.'

const clearErrorsAction = (payload) => {
  return {
    type: CLEAR_ERRORS,
    payload
  }
}

export { clearErrorsAction }
